import { render, staticRenderFns } from "./mobile-footer.vue?vue&type=template&id=3cfa11e2&scoped=true"
import script from "./mobile-footer.vue?vue&type=script&lang=ts"
export * from "./mobile-footer.vue?vue&type=script&lang=ts"
import style0 from "./mobile-footer.vue?vue&type=style&index=0&id=3cfa11e2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfa11e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cfa11e2')) {
      api.createRecord('3cfa11e2', component.options)
    } else {
      api.reload('3cfa11e2', component.options)
    }
    module.hot.accept("./mobile-footer.vue?vue&type=template&id=3cfa11e2&scoped=true", function () {
      api.rerender('3cfa11e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "layout/mobile-footer.vue"
export default component.exports